module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fmtitle"
  }, [_vm._v("List of Illustrations")]), _vm._v(" "), _c('p', {
    staticClass: "leaf1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "9",
      "src": "images/leaf.jpg",
      "width": "28"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('b', [_vm._v("In-text illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimgii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/01_Half#imgii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. ii Sir John Malcolm (Chalk drawing by William Bewicke. Reproduced by permission of the Scottish National Portrait Gallery.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg32"
    }
  }), _c('a', {
    attrs: {
      "href": "#/13_Chapter02#img32"
    }
  }, [_vm._v("p. 32 View of Seringapatam from the north-east, 1791. (Drawing by I. Smith, included in A Dirom, "), _c('i', [_vm._v("A Narrative of the Campaign in India")]), _vm._v(", 1791. Reproduced by permission of the National Library of Scotland.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg37"
    }
  }), _c('a', {
    attrs: {
      "href": "#/14_Chapter03#img37"
    }
  }, [_vm._v("p. 37 Henry Dundas, Viscount Melville (1747–1811). (Painting by Henry Raeburn, reproduced by permission of the Lloyds Banking Group, Bank of Scotland.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg41"
    }
  }), _c('a', {
    attrs: {
      "href": "#/14_Chapter03#img41"
    }
  }, [_vm._v("p. 41 General Sir Alured Clarke (1745–1832). (Engraving by unknown artist. Private collection.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg60"
    }
  }), _c('a', {
    attrs: {
      "href": "#/15_Chapter04#img60"
    }
  }, [_vm._v("p. 60 James Achilles Kirkpatrick (1764–1805). (Portrait by Chinnery, 1805. Private collection.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg92"
    }
  }), _c('span', {
    attrs: {
      "href": "#/18_Chapter06#img92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 92 Jonathan Duncan (1756–1811), Governor of Bombay. (Drawing by Mesquerier. Reproduced by permission of the Scottish National Portrait Gallery.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg110"
    }
  }), _c('span', {
    attrs: {
      "href": "#/19_Chapter07#img110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 110 Persepolis carving made by Malcolm and his party in 1800. (Photograph by Julian Lush.)")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg113"
    }
  }), _c('span', {
    attrs: {
      "href": "#/19_Chapter07#img113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 113 Fath Ali Shah (1772–1834). (Engraving by C. Heath, from an original Persian painting. Reproduced by permission of the National Library of Scotland.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg159"
    }
  }), _c('span', {
    attrs: {
      "href": "#/24_Chapter12#img159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 159 Mahratta Cavalry. (Drawing by unknown Indian artist, included in A. Dirom, "), _c('i', [_vm._v("A Narrative of the Campaign in India,")]), _vm._v(" 1791–2. Reproduced by permission of the National Library of Scotland.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg162"
    }
  }), _c('span', {
    attrs: {
      "href": "#/24_Chapter12#img162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 162 Colonel (later Major General) Sir Barry Close (1758–1813). (Painting by an Indian artist, copied by Moore. Reproduced courtesy of the Oriental Club, London.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg206"
    }
  }), _c('span', {
    attrs: {
      "href": "#/26_Chapter14#img206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 206 John Leyden (1775–1811). (Ink drawing 1811. Frontispiece of John Reith’s "), _c('i', [_vm._v("Life of Dr John Leyden")]), _vm._v(", 1908. Reproduced by permission of the National Library of Scotland.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg216"
    }
  }), _c('span', {
    attrs: {
      "href": "#/27_Chapter15#img216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 216 General Sir Gerard (later Viscount) Lake (1744–1808). (Painting by an unknown artist. Reproduced courtesy of the Oriental Club, London.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg239"
    }
  }), _c('span', {
    attrs: {
      "href": "#/28_Chapter16#img239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 239 Gilbert Elliot, 1st Earl of Minto (1757–1814). (Painting by Chinnery, 1811. Reproduced by permission of the Scottish National Portrait Gallery.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg248"
    }
  }), _c('span', {
    attrs: {
      "href": "#/29_Chapter17#img248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 248 Sir Harford Jones Bt (1764–1847). (Painting by Sir Thomas Lawrence. Reproduced by permission of the Bridgeman Art Library, London.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg273"
    }
  }), _c('span', {
    attrs: {
      "href": "#/30_Chapter18#img273",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 273 Sir George Barlow Bt (1762–1846). (Painting by an unknown artist. Reproduced by permission of the National Portrait Gallery, London).")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg282"
    }
  }), _c('span', {
    attrs: {
      "href": "#/30_Chapter18#img282",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 282 Charles Grant (1746–1823). (Chalk drawing by an unknown artist. Frontispiece of Henry Morris’s "), _c('i', [_vm._v("The Life of Charles Grant")]), _vm._v(", 1904. Reproduced by permission of the National Library of Scotland.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg306"
    }
  }), _c('span', {
    attrs: {
      "href": "#/31_Chapter19#img306",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 306 Abbas Mirza (1789–1833). (Drawing by R. Ker Porter, included in his "), _c('i', [_vm._v("Travels in Georgia, Persia etc 1817–1820.")]), _vm._v(" Reproduced by permission of the National Library of Scotland).")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg310"
    }
  }), _c('span', {
    attrs: {
      "href": "#/32_Chapter20#img310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 310 Claudius James Rich (1787–1821). (Painting by an unknown artist. Reproduced by permission of the British Library.)")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg333"
    }
  }), _c('span', {
    attrs: {
      "href": "#/35_Chapter22#img333",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 333 Sir James Mackintosh (1765–1832). (Painting by an unknown artist. Private collection.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg340"
    }
  }), _c('span', {
    attrs: {
      "href": "#/36_Chapter23#img340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 340 General Sir Charles William Pasley (1780–1861). (Painting by Charles B. Leighton. Reproduced by permission of the Royal School of Military Engineering, Chatham.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg369"
    }
  }), _c('span', {
    attrs: {
      "href": "#/38_Chapter24#img369",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 369 Francis Rawdon, Earl of Moira, later Marquess Hastings (1754–1826). (Painting by S. Lane. Reproduced courtesy of the Oriental Club, London.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg388"
    }
  }), _c('span', {
    attrs: {
      "href": "#/39_Chapter25#img388",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pp. 388–389 The Battle of Mehidpoor (21 December 1817). (Drawing by an unknown artist. Frontispiece of Valentine Blacker’s "), _c('i', [_vm._v("The Mahratta War 1817–1819")]), _vm._v(". Reproduced courtesy of the Oriental Club, London.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg436"
    }
  }), _c('span', {
    attrs: {
      "href": "#/41_Chapter27#img436",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 436 Charles Metcalfe (1785–1846). (Painting by F. R. Say. Reproduced courtesy of the Oriental Club, London.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg440a"
    }
  }), _c('span', {
    attrs: {
      "href": "#/42_part06#img440a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 440 Mountstuart Elphinstone (1779–1859). (Painting by H. W. Pickersgill. Reproduced courtesy of the Oriental Club, London).")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg440b"
    }
  }), _c('span', {
    attrs: {
      "href": "#/42_part06#img440b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 440 Major-General Sir Thomas Munro (1761–1827). (Painting by R. R. Reinagle. Reproduced courtesy of the Oriental Club, London.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg458"
    }
  }), _c('span', {
    attrs: {
      "href": "#/44_Chapter29#img458",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 458 Carving at Dendera, Temple of Hathore, Upper Egypt, 1822. (Photograph by Bini Malcolm. Private collection.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg463a"
    }
  }), _c('span', {
    attrs: {
      "href": "#/44_Chapter29#img463a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 463 William Whewell (1794–1866). (Painting by James Lonsdale c.1821. Reproduced by permission of the Master and Fellows of Trinity College, Cambridge.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg463b"
    }
  }), _c('span', {
    attrs: {
      "href": "#/44_Chapter29#img463b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 463 Adam Sedgwick (1785–1873). (Painting by Lowes Dickinson. Reproduced by permission of the Sedgwick Museum, Cambridge.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg511"
    }
  }), _c('span', {
    attrs: {
      "href": "#/45_Chapter30#img511",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 511 Plaque beside the Bhore Ghaut freeway. (Photograph by Bini Malcolm. Private collection.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg524"
    }
  }), _c('span', {
    attrs: {
      "href": "#/46_Chapter31#img524",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 524 Edward Law, Lord Ellenborough (1790–1871). (Painting by F. R. Say. Reproduced by permission of the National Portrait Gallery, London.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg548a"
    }
  }), _c('span', {
    attrs: {
      "href": "#/48_Postcript#img548a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 548 Sir John Malcolm. Statue in Westminster Abbey. (Sculpted by Sir Francis Chantrey. Copyright, Dean and Chapter of Westminster Abbey.)")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "yimg548b"
    }
  }), _c('span', {
    attrs: {
      "href": "#/48_Postcript#img548b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 548 Obelisk on Whita Hill, Langholm. (Photograph by Bini Malcolm. Private collection.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('b', [_vm._v("Plates")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Burnfoot and Douglen farms in the eighteenth century. (Unknown artist, Private collection.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 River Esk, near Burnfoot. (Photograph: Bini Malcolm.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 George Malcolm (1729–1803), father of John Malcolm. (Painting by Henry Raeburn c.1800. Private collection.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Margaret, ‘Bonnie Peggy’, Malcolm (1742–1811), mother of John Malcolm. (Painting by Henry Raeburn c.1800. By permission of the Courtauld Gallery, London.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Douglen Cottage, where John Malcolm was born. (Reproduced by permission of the National Gallery of Scotland.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Westerkirk Schoolhouse. (Photograph: Bini Malcolm.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Fort St George, Madras, from the sea. (Painting by G. Lambert and S. Scott. Reproduced by permission of the British Library.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Tipu Sultan, Ruler of Mysore, 1782–1799. (Drawing by an unknown Indian artist. Reproduced courtesy of the Oriental Club, London.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Lord Cornwallis and the sons of Tipu, 1792. (Painting by Mather Brown. Reproduced courtesy of the Oriental Club, London.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Richard Wellesley (1760–1842). Bust by Noellekens. (Reproduced by permission of the Provost and Fellows of Eton College.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Meer Alam (?1760–1809), c.1799, the Nizam of Hyderabad’s "), _c('i', [_vm._v("vakeel")]), _vm._v(" to the British. (Painting by an unknown Indian artist. Reproduced by permission of the Salar Jung Museum, Hyderabad.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl12"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 The Nizam and his durbar on a hunting expedition. (Painting by Venkatchellam. Reproduced by permission of the Salar Jung Museum, Hyderabad.)")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl13"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 William Kirkpatrick in Madras, c.1799, with his assistants and Persian munshis. (Painting by Thomas Hickey. Reproduced by permission of the National Gallery of Ireland.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl14"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Persepolis – a contemporary view. (Drawing by James Morier, c.1811. Reproduced by permission of the National Gallery of Scotland.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl15"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Government House Calcutta. (Engraving by James Baillie Fraser, from "), _c('i', [_vm._v("Views of Calcutta,")]), _vm._v(" 1821. Reproduced by permission of the National Gallery of Scotland.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl16"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Baji Rao II, Peshwah of Poona (1775–1851). (Painting by an unknown Indian artist. Reproduced courtesy of Wellcome Images.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl17"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Sir Arthur Wellesley and his favourite charger Diomed. (Painting by John Hoppner in 1806. Reproduced courtesy of the Trustees of the Stratfield Saye Preservation Trust.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl18"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 Dowlat Rao Scindiah (1781–1827). (Painting by an unknown Indian artist. Reproduced courtesy of Her Highness Shrimant Maharani Sir Jivaji Rao Scindia Museum, Gwalior.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl19"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 Tiger Hunt in India, c.1795 (Painting by an unknown artist. Reproduced by permission of the British Library.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl20"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 British Envoys at the Persian Court, 1808–1811. (Painting by an unknown Persian artist. Reproduced by permission of the Bridgeman Art Library, London.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl21"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 Lady Charlotte Malcolm and her children in 1815. (Drawing by George Hayter, 1815. Private collection.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl22"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 Sword of the Maharajah Holkar. (Reproduced courtesy of the Victoria and Albert Museum, London.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl23"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23 The Fortress of Asirgarh. (Photograph by Bini Malcolm.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl24"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24 Nalcha, near Mandu. (Photograph by Bini Malcolm.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl25"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25 Mehmet Ali, Pasha of Egypt (1769–1849). (Painting by Thomas Brigstock. Reproduced courtesy of the Oriental Club, London.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl26"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26 Hyde Hall, Hertfordshire. (Drawing by J. P. Neale 1819. Reproduced by permission of Cambridge University Library.)")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl27"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27 Malcolm’s meeting with Sahajanand Swami. (Painting by an unknown Indian artist. Reproduced courtesy of Bochsanawasi Shri Akshar Purushottam Swaminarayan Sanstha (BAPS).)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl28"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28 The Duke of Wellington, elder statesman. (Painting by H. W. Pickersgill. Reproduced courtesy of the Oriental Club, London.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl29"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29 India House, Leadenhall Street, London, headquarters of the East India Company. (Print from Ackermann, "), _c('i', [_vm._v("Views of London")]), _vm._v(". Reproduced by permission of the British Library.)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "ypl30"
    }
  }), _c('span', {
    attrs: {
      "href": "#/62_Plates#pl30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30 Lady Charlotte Malcolm in 1840. (Painting by Sir Francis Grant. Private collection.)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44712ebb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_Illustrations.vue
// module id = 69
// module chunks = 0